import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import {
    loginWebUser,
    loginAppUser,
    logoutWebUser,
    clearLocalUser,
    loginB2CUser
} from '../../../Auth/AuthActions'
import { toggleLoginModal } from '../../../actions'
import { Spinner } from 'components/Loaders/Loaders'
import Portal from 'components/Portal/Portal'
import { Modal } from 'components/Modal/Modal'
import { Body } from 'components/Shell/Shell'
import './Login.scss'
import FloatingMenu from 'components/FloatingMenu/FloatingMenu'
import { history } from '../../../store'
import { noop, parseUrlQuery, getAuthRedirectUrl } from 'utilities'
import CreateAccountForm from './CreateAccount'
import ForgotPasswordForm from './ForgotPasswordForm'
import ForgotUsernameForm from './ForgotUsernameForm'
import ReactMarkdown from 'components/Markdown/Markdown'
import UserAccountEditor from 'components/UserAccountEditor/UserAccountEditor'
import * as api from '../../../requests';
import Cookies from 'js-cookie';
import { MsalLogin, UnauthorizedLoginInstructions } from '../../Msal/MsalLogin';
import { MsalAuthTypes } from '../../Msal/MsalAuthTypes'

let Okta = () => null
////////////////////////
/////////////////////////////////////////////////
//////////

let MiLogin = () => null;
///////////////////////////
////////////////////////////////////////////////////////////
//////////

let msalFunctions = () => null;
if (process.env.USE_ND_LOGIN) {
    msalFunctions = require('components/Msal/MsalLogin.js');
}

let loginHeaderImg
if (process.env.LOGIN_HEADER_IMG_PATH) {
    loginHeaderImg = require(`../../../common/img/${process.env.LOGIN_HEADER_IMG_PATH}`)
}

let STATE_ABBR = process.env.STATE_ABBR
STATE_ABBR = STATE_ABBR.toUpperCase()
let SEAL_FILENAME = process.env.SEAL_FILENAME
let LOGIN_SEAL_FILENAME = process.env.LOGIN_SEAL_FILENAME
const stateSeal = require('../../../common/img/seals/' +
    STATE_ABBR +
    (LOGIN_SEAL_FILENAME
        ? `/${LOGIN_SEAL_FILENAME}`
        : SEAL_FILENAME
            ? `/${SEAL_FILENAME}`
            : '/seal.svg'))
const ALLOW_USER_PROFILE_EDITING = process.env.ALLOW_USER_PROFILE_EDITING
const FETCH_EDIT_USER_LINK = process.env.FETCH_EDIT_USER_LINK
class Auth extends Component {
    constructor() {
        super()
        this.state = {
            alignTo: null,
            menuOpen: false,
            editingUserAccount: false
        }
        this.modalref = createRef()
    }

    redirectToMiLogin = (settings) => {
        window.location.href = `${settings.autoProvisionUrl}`;
    };

    miLoginErrorCallback = (errors) => {
        console.error(errors);
    }

    toggleLoginModal = () => {
        if (process.env.LOGIN_REDIRECTS_TO_EPASS || process.env.HAS_KEYSTONE_LOGIN) {
            history.push(getAuthRedirectUrl({ pathname: this.props.pathname, search: this.props.search }))
        } else if (process.env.HAS_MILOGIN) {
            let userType = Cookies.get('milogin-usertype');

            if (userType === undefined) {
                console.warn('Unable to determine MI Login User Type! Setting usertype to Business...');
                userType = 'Business'
            }

            api.OIDC_VALUE(userType, this.redirectToMiLogin, this.miLoginErrorCallback);
        } else {
            if (!this.props.isOnAuthRoute) {
                this.props.toggleLoginModal(!this.props.showLogin)
            }
        }
    }
    componentDidUpdate = (prevProps) => {
        if (prevProps.loggedIn === false && this.props.loggedIn === true) {
            if (this.modalref.current) {
                this.modalref.current.closeModal()
            }
        }
        if (prevProps.siteOffline === true && this.props.siteOffline === false) {
            clearLocalUser(true)
        }
    }
    b2cLogin = (idToken) => {
        this.props.loginB2CUser(
            idToken,
            (success, err) => {
                if (this.props.onLogin && success) {
                    this.props.onLogin()
                } else {
                    this.setState({ error: err })
                }
            }
        );
    }
    logout = () => {
        this.props.logoutWebUser()

////////////////////////////////
//////////////////////////////
//////////////////

///////////////////////////////////
////////////////////////////////////
//////////////////

        if (this.props.ndLoginIsEnabled) {
            msalFunctions.msalFunctions.logout()
        }
    }
    openMenu = (e) => {
        this.setState({
            alignTo: e.currentTarget,
            menuOpen: true,
        })
    }
    closeMenu = () => {
        this.setState({
            menuOpen: false,
        })
    }
    startProfileEditor = () => this.setState({ editingUserAccount: true })
    closeProfileEditor = () => this.setState({ editingUserAccount: false })
    startExternalProfileEdit = () => { }

    mountOkta = (props) => {
        if (process.env.HAS_OKTA_LOGIN) {
            const showLoginButton = !props.checkingAuthState && !props.loggedIn && !props.siteOffline
            return (
                <Okta
                    ref={(ref) => {
                        this.okta = ref
                    }}
                    showLoginButton={showLoginButton}
                />
            )
        } else return null
    }

    mountMiLogin = (props) => {
        if (process.env.HAS_MILOGIN) {
            const showLoginButton = !props.checkingAuthState && !props.loggedIn && !props.siteOffline;

            return (
                <MiLogin
                    ref={(ref) => {
                        this.milogin = ref
                    }}
                    showLoginButton={showLoginButton}
                />
            )
        }

        return null;
    }

    renderAuth = (props) => {
        if (props.checkingAuthState) {
            return <Spinner className="loader" size="small" />
        } else if (props.siteOffline) {
            return null
        } else if (props.loggedIn) {
            return (
                <button aria-haspopup="true" className="user" onClick={this.openMenu}>
                    <span className="name">
                        {props.user.businessName ||
                            `${props.user.firstName || ''} ${props.user.lastName || ''}`}
                    </span>
                    <span dangerouslySetInnerHTML={{ __html: props.user.username.replace("@", "&#8203;@") }} className="username"></span>
                    <span className="visually-hidden">Click to edit settings and logout</span>
                </button>
            )
        } else if (props.ndLoginIsEnabled) {
            return (
                <MsalLogin authType={MsalAuthTypes.AzureB2C} ndLogin={this.b2cLogin} />
            )
        } else if (!props.isOnAuthRoute && !process.env.HAS_OKTA_LOGIN) {
            return (
                <button className="btn btn-default login-link" onClick={this.toggleLoginModal}>
                    {process.env.LOGIN_LABEL || 'Login'}
                </button>
            )
        } else return null
    }

    render() {
        const { showLogin, loggedIn, location, editUserExternalUrl } = this.props
        return (
            <div className="auth">
                {this.renderAuth(this.props)}
                {this.mountOkta(this.props)}
                {this.mountMiLogin(this.props)}
                {this.state.menuOpen ? (
                    <FloatingMenu
                        options={[
                            { label: 'Logout', onClick: this.logout },
                            ...(ALLOW_USER_PROFILE_EDITING
                                ? [
                                    {
                                        label: process.env.EDIT_ACCOUNT_LABEL || 'Edit My Account',
                                        onClick: this.startProfileEditor,
                                    },
                                ]
                                : []),
                            ...(FETCH_EDIT_USER_LINK
                                ? [
                                    {
                                        label: process.env.EDIT_ACCOUNT_LABEL || 'Edit My Account',
                                        href: editUserExternalUrl,
                                        target: '_blank',
                                    },
                                ]
                                : []),
                        ]}
                        isOpen={this.state.menuOpen}
                        alignTo={this.state.alignTo}
                        alignScreenRight
                        offsetTop={50}
                        offsetRight={5}
                        animationDirection="right"
                        onRequestClose={this.closeMenu}
                    />
                ) : null}
                {!process.env.HAS_MILOGIN && !this.props.ndLoginIsEnabled ? (<Portal isOpened={showLogin && !loggedIn && !this.props.isOnAuthRoute}>
                    <Modal
                        hideHeader={true}
                        closeModal={() => this.props.toggleLoginModal(false)}
                        modalSize="fullscreen"
                        noBackground={true}
                        disableEntranceAnimation={true}
                        modalBodyClassName="login-modal-body"
                        rootClassName="login-modal-root"
                        save={noop}
                        cancel={noop}
                        ref={this.modalref}
                    >
                        <PublicLogin location={location} />
                    </Modal>
                </Portal>) : (null)}
                <UserAccountEditor
                    isOpen={this.state.editingUserAccount}
                    onClose={this.closeProfileEditor}
                />
            </div>
        )
    }
}
export default connect(
    (state) => ({
        showLogin: state.app.showLogin,
        loggedIn: state.auth.loggedIn,
        siteOffline: state.app.appSettings.WEBSITE_PORTAL_OFFLINE_YN === true,
        user: {
            firstName: state.auth.FIRST_NAME,
            lastName: state.auth.LAST_NAME,
            username: state.auth.USERNAME,
            businessName: state.auth.BUSINESS_NAME,
            group: state.auth.USER_GROUP,
            roles: state.auth.ROLES,
        },
        checkingAuthState: state.auth.checkingAuthState,
        useLDAP:
            state.app.appSettings.USE_LDAP_AUTHENTICATION_YN == true
                ? state.app.appSettings.USE_LDAP_AUTHENTICATION_YN
                : false,
        isOnAuthRoute: state.router.location.pathname === '/auth',
        pathname: state.router.location.pathname,
        search: state.router.location.search,
        editUserExternalUrl: state.app.appSettings.EPASS_ACCOUNT_EDIT_URL,
        BOSS_URL: state.app.appSettings.BOSS_LOGIN_PAGE_URL,
        ndLoginIsEnabled: state.app.appSettings.ND_LOGIN_IS_ENABLED === true
    }),
    {
        toggleLoginModal,
        logoutWebUser,
        loginB2CUser
    }
)(Auth)

const DOUBLE_COLUMN_PUBLIC_LOGIN = process.env.DOUBLE_COLUMN_PUBLIC_LOGIN
const REVERSE_LOGIN_COLUMNS = process.env.REVERSE_LOGIN_COLUMNS
const LOGIN_HEADER_BACKGROUND = process.env.LOGIN_HEADER_BACKGROUND
const LOGIN_FORGOT_USERNAME_LABEL = process.env.LOGIN_FORGOT_USERNAME_LABEL
const LOGIN_FORGOT_PASSWORD_LABEL = process.env.LOGIN_FORGOT_PASSWORD_LABEL
const LOGIN_FOOTER_TEXT = process.env.LOGIN_FOOTER_TEXT

export class PublicLogin extends Component {
    state = {
        error: null,
        activeView: 'login',
        forgotSuccess: false,
        loginMessage: null,
        changedSuccess: false,
    }
    componentDidMount = () => {
        if (this.props.location) {
            const { page, changed } = parseUrlQuery(this.props.location.search)
            const allowedStartPages = ['login', 'forgot', 'create']
            if (allowedStartPages.includes(page)) {
                this.setState({ activeView: page })
            }
            if (changed) {
                this.setState({ changedSuccess: true })
            }
        }
    }
    login = () => {
        this.props.loginWebUser(
            {
                username: this.loginForm.getUsername(),
                password: this.loginForm.getPassword(),
            },
            (success, err) => {
                if (this.props.onLogin && success) {
                    this.props.onLogin()
                } else {
                    this.setState({ error: err })
                }
            }
        )
    }
    checkEnter = ({ keyCode }) => {
        if (keyCode === 13) {
            if (this.state.error === null) {
                this.login()
            }
        } else {
            if (this.state.error) {
                this.setState({ error: null })
            }
        }
    }
    setActiveViewCreate = () => {
        this.setState({
            activeView: 'create',
            forgotSuccess: false,
            changedSuccess: false,
            loginMessage: null,
        })
    }
    setActiveViewLogin = (message) => {
        this.setState({ activeView: 'login', forgotSuccess: false, changedSuccess: false })
        if (message.hasOwnProperty('message')) {
            this.setState({
                loginMessage: message,
            })
        }
    }
    setActiveViewForgot = () => {
        this.setState({
            activeView: 'forgot',
            forgotSuccess: false,
            changedSuccess: false,
            loginMessage: null,
        })
    }
    setActiveViewForgotUsername = () => {
        this.setState({
            activeView: 'forgotUsername',
            forgotUsernameSuccess: false,
            changedSuccess: false,
            loginMessage: null,
        })
    }
    setLoginViewWithForgotUsernameSuccess = () => {
        this.setState({
            activeView: 'login',
            forgotUsernameSuccess: true,
        })
    }
    setLoginViewWithForgotSuccess = () => {
        this.setState({
            activeView: 'login',
            forgotSuccess: true,
            changedSuccess: false,
        })
    }
    render() {
        const loginActive = this.state.activeView === 'login'
        const doubleColumn = DOUBLE_COLUMN_PUBLIC_LOGIN && loginActive
        const { siteOffline } = this.props

        if(this.props.ndLoginIsEnabled) {
            return <UnauthorizedLoginInstructions/>
        }
        return (
            <div
                className={`admin-login-wrapper login-modal-new animated fadeInDown fast-animation ${doubleColumn ? 'double-column' : ''
                    } ${process.env.LOGIN_HEADER_STYLE === 'full-width' ? 'has-full-width-banner' : ''}
           ${LOGIN_FOOTER_TEXT ? 'has-footer' : ''}`}
            >
                {siteOffline && <Redirect to="/" />}
                {process.env.LOGIN_HEADER_STYLE === 'full-width' && (
                    <div
                        className="full-width-banner"
                        style={LOGIN_HEADER_BACKGROUND ? { background: LOGIN_HEADER_BACKGROUND } : undefined}
                    >
                        {process.env.LOGIN_HEADER_IMG_PATH && (
                            <img
                                src={loginHeaderImg}
                                alt={`${process.env.STATE_NAME} Login`}
                                style={{ marginLeft: '20px', marginTop: '15px' }}
                            />
                        )}
                    </div>
                )}
                <div className={`row ${REVERSE_LOGIN_COLUMNS ? 'reverse' : ''}`}>
                    <div
                        className={`${doubleColumn ? 'col-sm-6' : 'col'} login-column left`}
                        style={{
                            paddingTop: process.env.LOGIN_HEADER_IMG_PATH ? '' : 95,
                        }}
                    >
                        {process.env.LOGIN_HEADER_STYLE !== 'full-width' &&
                            (process.env.LOGIN_HEADER_IMG_PATH ? (
                                <img
                                    src={loginHeaderImg}
                                    alt={`${process.env.STATE_NAME} Login`}
                                    style={{ marginLeft: '20px', marginTop: '15px' }}
                                />
                            ) : REVERSE_LOGIN_COLUMNS && loginActive ? null : (
                                <div className="banner">
                                    {this.state.activeView === 'create' && `Create ${process.env.STATE_NAME} Account`}
                                    {this.state.activeView === 'login' &&
                                        (process.env.LOGIN_TITLE || `${process.env.STATE_NAME} Login`)}
                                    {this.state.activeView === 'forgot' && `Forgot Password`}
                                </div>
                            ))}
                        {this.state.forgotSuccess && (
                            <div className="info">
                                A link to change your password has been sent to your email. Please allow a few
                                minutes for this message to arrive.
                            </div>
                        )}
                        {this.state.changedSuccess && (
                            <div className="info">
                                Password successfully updated, please login with your new password below.
                            </div>
                        )}
                        {this.state.loginMessage && (
                            <div className={`info ${this.state.loginMessage.type || ''}`}>
                                {this.state.loginMessage.message}
                            </div>
                        )}
                        {this.state.activeView === 'create' && (
                            <CreateAccountForm returnToLogin={this.setActiveViewLogin} />
                        )}
                        {this.state.activeView === 'login' && (
                            <LoginForm
                                ref={(ref) => (this.loginForm = ref)}
                                checkEnter={this.checkEnter}
                                error={this.state.error}
                                login={this.login}
                                startAccountCreation={this.setActiveViewCreate}
                                startForgotPassword={this.setActiveViewForgot}
                                startForgotUsername={this.setActiveViewForgotUsername}
                                pathname={this.props.pathname}
                                search={this.props.search}
                                setStateUser={this.props.setStateUser}
                                toggleLoginModal={this.props.toggleLoginModal}
                            />
                        )}
                        {this.state.activeView === 'forgot' && (
                            <ForgotPasswordForm
                                returnToLogin={this.setActiveViewLogin}
                                returnAndDisplaySuccess={this.setLoginViewWithForgotSuccess}
                            />
                        )}
                        {this.state.activeView === 'forgotUsername' && (
                            <ForgotUsernameForm
                                returnToLogin={this.setActiveViewLogin}
                                returnAndDisplaySuccess={this.setLoginViewWithForgotUsernameSuccess}
                            />
                        )}
                    </div>
                    {doubleColumn && (
                        <LoginInformationColumn
                        startAccountCreation={this.setActiveViewCreate}
                        banner={
                            loginActive && REVERSE_LOGIN_COLUMNS && DOUBLE_COLUMN_PUBLIC_LOGIN
                                ? process.env.LOGIN_TITLE
                                : undefined
                        }
                        />
                    )}
                </div>
                {LOGIN_FOOTER_TEXT && <ReactMarkdown className="login-footer" source={LOGIN_FOOTER_TEXT} />}
            </div>
        )
    }
}
PublicLogin = connect(
    (state) => ({
        user: state.app.user,
        siteOffline: state.app.appSettings.WEBSITE_PORTAL_OFFLINE_YN === true,
        ndLoginIsEnabled: state.app.appSettings.ND_LOGIN_IS_ENABLED === true
    }),
    { loginWebUser }
)(PublicLogin)

const LOGIN_CREATE_PERSONAL_LINK = process.env.LOGIN_CREATE_PERSONAL_LINK
const LOGIN_CREATE_BUSINESS_LINK = process.env.LOGIN_CREATE_BUSINESS_LINK
const LOGIN_FORGOT_PASSWORD_LINK = process.env.LOGIN_FORGOT_PASSWORD_LINK
const LOGIN_FORGOT_USERNAME_LINK = process.env.LOGIN_FORGOT_USERNAME_LINK
const LOGIN_UPDATE_ACCOUNT_LINK = process.env.LOGIN_UPDATE_ACCOUNT_LINK
const LOGIN_LINK_STYLE = process.env.LOGIN_LINK_STYLE
const INLINE_LOGIN_LINKS = LOGIN_LINK_STYLE === 'inline'
const GROUPED_LOGIN_LINKS = LOGIN_LINK_STYLE === 'grouped'
const LOGIN_ALREADY_REGISTERED_LINK = process.env.LOGIN_ALREADY_REGISTERED_LINK

class LoginForm extends Component {
    componentDidMount = () => {
        this.username.focus()
    }
    getUsername = () => this.username.value
    getPassword = () => this.password.value
    render() {
        const {
            checkEnter,
            error,
            login,
            startAccountCreation,
            startForgotPassword,
            // startForgotUsername,
        } = this.props
        return (
            <form className="login">
                {LOGIN_ALREADY_REGISTERED_LINK && (
                    <h5 className="subtitle">
                        Already Registered - <a href={LOGIN_ALREADY_REGISTERED_LINK}>Not sure?</a>
                    </h5>
                )}
                <div className="field">
                    <label htmlFor="username">{process.env.PUBLIC_LOGIN_LABEL || 'User ID'}</label>
                    <input
                        type="text"
                        ref={(ref) => {
                            this.username = ref
                        }}
                        id="username"
                        name="username"
                        maxLength={100}
                        onKeyDown={checkEnter}
                        placeholder={process.env.PUBLIC_LOGIN_PLACEHOLDER || 'example@email.com'}
                    />
                    {LOGIN_FORGOT_USERNAME_LINK && INLINE_LOGIN_LINKS && (
                        <div className="flex-right">
                            <a target="blank" href={LOGIN_FORGOT_USERNAME_LINK}>
                                {LOGIN_FORGOT_USERNAME_LABEL || 'Forgot username?'}
                            </a>
                        </div>
                    )}
                </div>
                <div className="field">
                    <label htmlFor="password">Password</label>
                    <input
                        type="password"
                        ref={(ref) => {
                            this.password = ref
                        }}
                        id="password"
                        name="password"
                        onKeyDown={checkEnter}
                    />
                    {LOGIN_FORGOT_PASSWORD_LINK && INLINE_LOGIN_LINKS && (
                        <div className="flex-right">
                            <a target="blank" href={LOGIN_FORGOT_PASSWORD_LINK}>
                                {LOGIN_FORGOT_PASSWORD_LABEL || 'Forgot password?'}
                            </a>
                        </div>
                    )}
                </div>
                <div className="button-wrapper">
                    {error && (
                        <span className="error animated fadeIn fast-animation">
                            <ReactMarkdown source={error} className="markdown" />
                        </span>
                    )}
                    <button
                        type="button"
                        // disabled={error ? true : false}
                        className="btn-raised btn-light-primary submit"
                        onClick={login}
                    >
                        <span className="icon icon-lock" />
                        &nbsp; LOGIN
                    </button>
                    {LOGIN_FORGOT_PASSWORD_LINK && GROUPED_LOGIN_LINKS && (
                        <a target="blank" href={LOGIN_FORGOT_PASSWORD_LINK}>
                            Forgot password?
                        </a>
                    )}
                    {LOGIN_FORGOT_USERNAME_LINK && GROUPED_LOGIN_LINKS && (
                        <a target="blank" href={LOGIN_FORGOT_USERNAME_LINK}>
                            Forgot username?
                        </a>
                    )}
                    {LOGIN_UPDATE_ACCOUNT_LINK && (GROUPED_LOGIN_LINKS || INLINE_LOGIN_LINKS) && (
                        <a target="blank" href={LOGIN_UPDATE_ACCOUNT_LINK}>
                            Update your account
                        </a>
                    )}
                </div>
                {process.env.INTERNAL_USER_MANAGEMENT && (
                    <div className="button-wrapper create-wrapper">
                        <button type="button" className="create-account-button" onClick={startForgotPassword}>
                            Forgot or Change Password?
                        </button>
                    </div>
                )}
                {/* {process.env.INTERNAL_USER_MANAGEMENT && process.env.FORGOT_USERNAME_TEXT && (
          <div className="button-wrapper create-wrapper">
            <button type="button" className="create-account-button" onClick={startForgotUsername}>
              {process.env.FORGOT_USERNAME_TEXT || 'Forgot Username?'}
            </button>
          </div>
        )} */}
                {process.env.INTERNAL_USER_MANAGEMENT && !REVERSE_LOGIN_COLUMNS && (
                    <div className="button-wrapper create-wrapper">
                        <button type="button" className="create-account-button" onClick={startAccountCreation}>
                            Create an account
                        </button>
                    </div>
                )}
            </form>
        )
    }
}

const LoginInformationColumn = ({ startAccountCreation, banner }) => (
    <div className="col-sm-6 login-column right">
        {banner && (
            <div className="banner span-2-columns">
                <img src={stateSeal} alt="Idaho state seal" /> {banner}
            </div>
        )}
        <div
            className={`instructions markdown ${banner ? 'has-banner' : ''} ${process.env.PUBLIC_LOGIN_CREATE_DESCRIPTION ? 'has-own-instructions' : ''
                }`}
        >
            {process.env.PUBLIC_LOGIN_CREATE_DESCRIPTION ? (
                <React.Fragment>
                    <ReactMarkdown
                        source={process.env.PUBLIC_LOGIN_CREATE_DESCRIPTION}
                        className="markdown markdown-instructions"
                    />
                    <div className="right-align">
                        <button
                            type="button"
                            className="btn btn-raised btn-light-primary submit"
                            style={{ marginTop: 9, marginBottom: 12 }}
                            onClick={startAccountCreation}
                        >
                            Create an account
                        </button>
                        <a href="https://sos.idaho.gov/sosbiz-help/">Get Detailed Instructions</a>
                    </div>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <h6>New to {process.env.STATE_NAME} Online Services?</h6>
                    {/* <p>Login into your {process.env.STATE_NAME} Login account to:</p> */}
                    <p>Register now!</p>
                    <div className="login-create-buttons-wrapper">
                        <div>
                            <a href={LOGIN_CREATE_PERSONAL_LINK} className="btn btn-raised btn-primary">
                                Personal Account
                            </a>
                        </div>
                        <div>
                            <a href={LOGIN_CREATE_BUSINESS_LINK} className="btn btn-raised btn-primary">
                                Business Account
                            </a>
                        </div>
                    </div>
                    <p>Benefits of {process.env.STATE_NAME} Login</p>
                    <ul>
                        <li>
                            One {process.env.STATE_NAME} Login and password to access multiple{' '}
                            <a href="https://www.nd.gov/government/citizen-services" target="_blank">
                                {process.env.STATE_ABBR} Online Services
                            </a>
                        </li>
                        <li>Register once for secure access to State services</li>
                    </ul>
                    <p>
                        Need help? Read through the{' '}
                        <a target="_blank" href="https://apps.nd.gov/itd/ldap/info.htm">
                            FAQ
                        </a>
                    </p>
                </React.Fragment>
            )}
        </div>
    </div>
)

export class AdminLogin extends Component {
    state = { error: null }
    componentDidMount = () => {
        if (this.email) {
            this.email.focus()
        }
    }
    loginAdmin = () => {
        this.props.loginAppUser(
            { username: this.email.value, password: this.pass.value },
            (success, err) => {
                if (success) {
                    let from = this.getFrom()
                    history.replace(from)
                } else {
                    this.setState({ error: err })
                }
            }
        )
    }
    getFrom = () => {
        const { from = '', search = '' } = parseUrlQuery(this.props.location.search)
        return this.props.location.search !== '' ? `${from}${search ? `&search=${search}` : ''}` : '/'
    }
    checkEnter = ({ keyCode }) => {
        if (keyCode === 13) {
            if (this.state.error === null) {
                this.loginAdmin()
            }
        } else {
            if (this.state.error) {
                this.setState({ error: null })
            }
        }
    }
    render() {
        const { loggedIn } = this.props
        if (process.env.HAS_OKTA_LOGIN) {
            return <Redirect to={`/auth?from=${this.getFrom()}`} replace />
        }
        return (
            <div className="admin-login-wrapper login-modal-new animated fadeInDown fast-animation">
                {loggedIn && <Redirect to={this.getFrom()} replace />}
                <div className="row" style={{ padding: '0px' }}>
                    <div className="col login-column left" style={{ paddingTop: 95 }}>
                        <div className="banner">
                            <span className="icon icon-lock" /> Administrator Login
                        </div>
                            <form className="login">
                            <div className="field">
                                <label>User ID</label>
                                <input
                                    type="text"
                                    ref={(email) => {
                                        this.email = email
                                    }}
                                    placeholder="example@email.com"
                                    onKeyDown={this.checkEnter}
                                    maxLength={100}
                                />
                            </div>
                            <div className="field">
                                <label>Password</label>
                                <input
                                    type="password"
                                    ref={(pass) => {
                                        this.pass = pass
                                    }}
                                    placeholder="********"
                                    onKeyDown={this.checkEnter}
                                />
                            </div>
                            <div className="button-wrapper">
                                {this.state.error && (
                                    <span className="error animated fadeIn fast-animation">{this.state.error}</span>
                                )}
                                <button
                                    type="button"
                                    // disabled={this.state.error ? true : false}
                                    className="btn-raised btn-light-primary submit"
                                    onClick={this.loginAdmin}
                                >
                                    <span className="icon icon-lock" />
                                    &nbsp; LOGIN
                                </button>
                            </div>
                            </form>
                    </div>
                </div>
            </div>
        )
    }
}
AdminLogin = connect(
    (state) => ({
        location: state.router.location,
        loggedIn: state.auth.loggedIn,
    }),
    { loginAppUser }
)(AdminLogin)

export class AdminLoginPage extends Component {
    render() {
        const { initialAuthCheck, siteOffline } = this.props
        return (
            <Body className="login-redirector">
                {siteOffline && <Redirect to="/" />}
                {!initialAuthCheck && <AdminLogin />}
            </Body>
        )
    }
}
AdminLoginPage = connect((state) => ({
    initialAuthCheck: state.auth.initialAuthCheck,
    siteOffline: state.app.appSettings.WEBSITE_PORTAL_OFFLINE_YN === true,
}))(AdminLoginPage)
